import script from "./moneyComponentViewColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./moneyComponentViewColumn.vue?vue&type=script&setup=true&lang=js"

import "./moneyComponentViewColumn.vue?vue&type=style&index=0&id=5dfd58fc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dfd58fc"]])

export default __exports__